(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaDeleteController',SistemaDeleteController);

    SistemaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sistema'];

    function SistemaDeleteController($uibModalInstance, entity, Sistema) {
        var vm = this;

        vm.sistema = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sistema.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
